<template>
	<van-tabbar v-model="active" style="z-index: 1999">
		<van-tabbar-item
			v-for="(tab, index) in tabbar"
			:to="tab.path"
			:dot="tab.dot"
			:info="tab.info"
			:key="index">
			<!-- <van-icon  slot="icon" slot-scope="props"  :name="'icon-'+tab.icon"/> -->
			<i slot="icon" slot-scope="props"  :class="'icon-task icon-'+tab.icon"></i>
			{{tab.name}}
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
export default {
  name: 'tabbar',
  props: {
    tabbar: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      active: 0
    }
  },

  watch: {
    '$route': 'changeActive'
  },

  created () {
    const toName = this.$route.name
    this.setActive(toName)
  },

  methods: {
    changeActive ({ name }) {
      this.setActive(name)
    },
    setActive (name) {
      this.tabbar.forEach((tab, i) => {
        if (tab.pathName == name) {
          this.active = i
          return false
        }
      })
    }
  }
}

</script>
